import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContentStateService } from 'src/app/views/content/content-state.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoadingState } from '../content-display-card/content-display-card.component';

@Component({
  selector: 'app-loading-indicator',
  imports: [MatProgressSpinnerModule, MatIconModule],
  template: `
    <div class="loader-container">
      @switch (displayState().status) {
        @case ('loading') {
          <mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner>
          @if (displayState().message) {
            <span class="loader-message">{{ displayState().message }}</span>
          }
        }
        @case ('success') {
          <mat-icon class="success-icon">check_circle</mat-icon>
          @if (displayState().message) {
            <span class="loader-message success-message">{{ displayState().message }}</span>
          }
        }
        @case ('error') {
          <mat-icon class="error-icon">error</mat-icon>
          @if (displayState().message) {
            <span class="loader-message error-message">{{ displayState().message }}</span>
          }
        }
        @default {
          <div id="placeholder"></div>
        }
      }
    </div>
  `,
  styles: `
    .loader-container {
      display: flex;
      align-items: center;
      gap: 8px;
      min-height: 24px;

      .loader-message {
        font-size: 14px;
      }

      .success-icon {
        color: #4caf50;
      }

      .error-icon {
        color: #f44336;
      }

      .success-message {
        color: #388e3c;
      }

      .error-message {
        color: #d32f2f;
      }
    }
  `,
})
export class LoadingIndicatorComponent {
  public contentStateService = inject(ContentStateService);
  private toastService = inject(ToastService);

  private toastState = toSignal(this.toastService.loadingIndicator$, { initialValue: { status: 'idle' } });

  displayState = computed<LoadingState>(() => {
    const contentState = this.contentStateService.loading();
    const toastState = this.toastState();

    if (contentState.status !== 'idle') {
      return contentState;
    }
    return toastState;
  });
}
